(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Star_tab_slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelectorAll('.star-products-container.swiper');
    section.forEach(section => {
        const swiper = new Swiper(section, {
            slidesPerView: section.getAttribute('data-per-row-m'),
            spaceBetween: 12,
            navigation: {
                nextEl: section.querySelector('.swiper-button-next'),
                prevEl: section.querySelector('.swiper-button-prev'),
            },
            scrollbar: {
                el: section.querySelector('.swiper-scrollbar'),
            },
            breakpoints: {
                749: {
                    slidesPerView: section.getAttribute('data-per-row'),
                    spaceBetween: 24,
                },
            },
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bkw-benefits"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function() {
        if(window.innerWidth > 749) {
            new Swiper(".bkw-benefits-section .blocks-grid", {
                slidesPerView: 3,
                spaceBetween: 15,
                navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
                },
                scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true,
                dragSize: 25,
                }
            });
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust-26-bkw-banner"] && !Shopify.designMode) return;
  try {
    
class BkwSubscriptionController {
  constructor(root) {
    this.id = root.id || root.closest('[id]')?.id || 'bkw-subscription';
    this.abort = new AbortController();
    this.boundForms = new Set();
    this.settings = JSON.parse(root.querySelector('[data-bkw-subscription-settings]').textContent);
    root.querySelectorAll('[data-bkw-subscription-form]').forEach(form => this.bindForm(form));
  }
  destroy() {
    this.abort.abort();
    this.boundForms.forEach(form => { delete form.dataset.bkwBound; });
    this.boundForms.clear();
  }
    bindForm(form) {
      if (this.boundForms.has(form)) return;
      this.boundForms.add(form);
      form.dataset.bkwBound = this.id;
      form.addEventListener('submit', event => { event.preventDefault(); this.submit(form); }, { signal: this.abort.signal });
    }
    async submit(form) {
      const settings = this.settings;
      const email = form.elements.email;
      const consent = form.elements.consent;
      const status = form.querySelector('[role="status"]');
      const button = form.querySelector('[type="submit"]');
      const show = message => { status.textContent = message; status.hidden = false; };
      email.removeAttribute('aria-invalid'); consent.removeAttribute('aria-invalid');
      if (!email.value.trim() || !email.validity.valid) { show(settings.email_error_text); email.setAttribute('aria-invalid', 'true'); email.focus(); return; }
      if (!consent.checked) { show(settings.disclaimer_error_text); consent.setAttribute('aria-invalid', 'true'); consent.focus(); return; }
      if (!settings.campaign_enabled || !settings.contact_list_id) { show(settings.not_open_text); return; }
      const integration = window.theme?.emailSubscription;
      if (!integration?.apiUrl) { show(settings.general_error_text); return; }
      const fields = [];
      for (const type of ['single', 'subscription_text', 'multiple']) {
        for (let i = 1; i <= 5; i += 1) {
          const prefix = `${type}_${i}_`;
          if (!settings[`${prefix}id`]) continue;
          let value = settings[`${prefix}value`];
          if (type === 'single') value = Number(value);
          if (type === 'multiple') value = String(value || '').split(',').filter(x => x.trim()).map(Number);
          if ((type === 'single' && !Number.isFinite(value)) || (Array.isArray(value) && value.some(x => !Number.isFinite(x)))) { show(settings.general_error_text); return; }
          fields.push({ id: String(settings[`${prefix}id`]), type: type === 'subscription_text' ? 'text' : type, value, overwrite: String(settings[`${prefix}overwrite`]) === 'true' });
        }
      }
      const original = button.textContent;
      button.disabled = true; button.setAttribute('aria-busy', 'true'); button.textContent = settings.loading_text;
      try {
        const response = await fetch(integration.apiUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', apiKey: integration.apiKey, traceId: crypto.randomUUID(), 'X-appid': integration.xAppid, 'Accepted-Language': integration.acceptedLanguage }, body: JSON.stringify({ email: email.value.trim(), contactListId: settings.contact_list_id, fields }), signal: this.abort.signal });
        const data = await response.json();
        if (!response.ok || data.message !== 'Success') throw new Error('Subscription failed');
        show(settings.success_message); form.reset();
      } catch (error) { if (error.name !== 'AbortError') show(settings.general_error_text); }
      finally { if (form.isConnected) { button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = original; } }
    }
}

if (!customElements.get('cust-26-bkw-banner')) {
  customElements.define('cust-26-bkw-banner', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new BkwSubscriptionController(this);
      const end = Date.parse(this.dataset.end);
      if (Number.isFinite(end)) {
        const update = () => {
          const total = Math.max(0, Math.floor((end - Date.now()) / 1000));
          const values = { days: Math.floor(total / 86400), hours: Math.floor(total / 3600) % 24, minutes: Math.floor(total / 60) % 60, seconds: total % 60 };
          this.querySelectorAll('[data-unit]').forEach(node => { node.textContent = String(values[node.dataset.unit]).padStart(2, '0'); });
        };
        update(); this.timer = setInterval(update, 1000);
      }
      let calendarUrl, calendarFallback, calendarObserver;
      const calendarOverlaySettings = new Map();
    const installCalendar = () => {
    const calendar = this.querySelector('add-to-calendar-button');
    if (calendar && !calendarOverlaySettings.has(calendar)) {
      calendarOverlaySettings.set(calendar, calendar.getAttribute('forceOverlay'));
    }
    if (calendar && calendar.getAttribute('forceOverlay') !== 'true') {
      calendar.setAttribute('forceOverlay', 'true');
    }
    if (calendar && !calendarFallback && !customElements.get('add-to-calendar-button')) {
      const start = new Date(this.dataset.end || `${calendar.getAttribute('startDate')}T${calendar.getAttribute('startTime')}:00`);
      if (Number.isFinite(start.getTime())) {
        const stamp = date => date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z');
        const escapeIcs = value => String(value || '').replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/[,;]/g, match => `\\${match}`);
        const ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//EcoFlow//Black Friday//EN', 'BEGIN:VEVENT', `UID:bkw-bf-26-${stamp(start)}@ecoflow.com`, `DTSTAMP:${stamp(new Date())}`, `DTSTART:${stamp(start)}`, `SUMMARY:${escapeIcs(calendar.getAttribute('name'))}`, `DESCRIPTION:${escapeIcs(calendar.getAttribute('description'))}`, 'END:VEVENT', 'END:VCALENDAR', ''].join('\r\n');
        calendarUrl = URL.createObjectURL(new Blob([ics], { type: 'text/calendar;charset=utf-8' }));
        calendarFallback = document.createElement('a');
        calendarFallback.className = 'bkw-bf-calendar-fallback';
        calendarFallback.href = calendarUrl;
        calendarFallback.download = 'ecoflow-black-friday.ics';
        calendarFallback.textContent = calendar.getAttribute('label');
        calendar.after(calendarFallback);
        customElements.whenDefined('add-to-calendar-button').then(() => { calendarFallback?.remove(); });
      }
    }
    };
    const calendarContainer = this.querySelector('.m11-bf-banner-calendar-btn');
    if (calendarContainer) {
      calendarObserver = new MutationObserver(installCalendar);
      calendarObserver.observe(calendarContainer, { childList: true });
      installCalendar();
    }
      this.cleanupCalendar = () => {
        calendarObserver?.disconnect(); calendarFallback?.remove();
        if (calendarUrl) URL.revokeObjectURL(calendarUrl);
        calendarOverlaySettings.forEach((value, calendar) => {
          if (value === null) calendar.removeAttribute('forceOverlay');
          else calendar.setAttribute('forceOverlay', value);
        });
        calendarOverlaySettings.clear();
      };
    }
    disconnectedCallback() {
      this.controller?.destroy(); this.controller = null;
      clearInterval(this.timer); this.cleanupCalendar?.(); this.cleanupCalendar = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust-26-bkw-button-tabs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cust-26-bkw-button-tabs')) {
  customElements.define('cust-26-bkw-button-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
  function select(tab) {
    const group = tab.closest('.ef-button-tabs--row');
    group?.querySelectorAll('.ef-section-button-tabs__tab-btn').forEach(button => {
      const active = button === tab;
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', String(active));
      ['firstSection','secondSection','thirdSection'].forEach(key => {
        const selector = button.dataset[key];
        if (!selector || !/^#bkw-bf-[a-z0-9-]+$/.test(selector)) return;
        const target = document.querySelector(selector);
        if (target) { target.hidden = !active; target.style.display = active ? 'block' : 'none'; }
      });
    });
  }

      const initialize = () => {
        const active = this.querySelector('button.active') || this.querySelector('button');
        if (active) select(active);
      };
      initialize();
      this.addEventListener('click', event => {
        const tab = event.target.closest('.ef-section-button-tabs__tab-btn');
        if (!tab || !this.contains(tab)) return;
        event.stopPropagation(); select(tab);
      }, { capture: true, signal: this.abort.signal });
      document.addEventListener('shopify:section:load', initialize, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust-26-bkw-common-title"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();
  function initialize(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const dialog = root.querySelector('.bkw-title-popup');
    const trigger = root.querySelector('[data-bkw-title-popup-open]');
    let previousOverflow;
    let previousFocus;
    let scrollLocked = false;

    function release() {
      if (!scrollLocked) return;
      document.documentElement.style.overflow = previousOverflow;
      scrollLocked = false;
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    }

    root.querySelectorAll('a[href=""]').forEach(link => {
      link.setAttribute('aria-disabled', 'true');
      link.addEventListener('click', event => event.preventDefault(), options);
    });
    if (dialog && trigger && typeof dialog.showModal === 'function') {
      trigger.addEventListener('click', () => {
        if (dialog.open) return;
        previousFocus = document.activeElement;
        dialog.showModal();
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        scrollLocked = true;
      }, options);
      root.querySelector('[data-bkw-title-popup-close]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('close', release, options);
      dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const focusable = Array.from(dialog.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'))
          .filter(element => element.getClientRects().length > 0);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }, options);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      }, options);
    }
    instances.set(root, () => {
      if (dialog?.open) dialog.close();
      release();
      controller.abort();
      instances.delete(root);
    });
  }
  function forEachRoot(scope, callback) {
    if (scope.matches?.('.cust-26-bkw-common-title')) callback(scope);
    scope.querySelectorAll('.cust-26-bkw-common-title').forEach(callback);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => forEachRoot(document, initialize), { once: true });
  else forEachRoot(document, initialize);
  document.addEventListener('shopify:section:load', event => forEachRoot(event.target, initialize));
  document.addEventListener('shopify:section:unload', event => forEachRoot(event.target, root => instances.get(root)?.()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust-bkw-bf-multiple-product"] && !Shopify.designMode) return;
  try {
    
class BkwProductController {
  constructor(root) {
    this.root = root;
    this.abort = new AbortController();
    this.mobileQuery = matchMedia('(max-width: 749px)');
    this.mobileQuery.addEventListener('change', () => {
      this.root.querySelectorAll('[data-bkw-card]').forEach(card => this.update(card));
    }, { signal: this.abort.signal });
    this.messages = JSON.parse(root.querySelector('[data-bkw-messages]').textContent);
    root.addEventListener('click', event => this.onClick(event), { signal: this.abort.signal });
    root.addEventListener('change', event => this.onChange(event), { signal: this.abort.signal });
    root.addEventListener('focusout', event => { if (event.target.matches('[data-addon-quantity]')) this.onChange(event); }, { signal: this.abort.signal });
    root.querySelectorAll('[data-bkw-card]').forEach(card => this.update(card));
    this.alignmentFrame = 0;
    this.observedAlignmentElements = new Set();
    this.alignmentResizeObserver = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(() => this.scheduleAlignment());
    this.alignmentMutationObserver = new MutationObserver(() => {
      this.observeAlignmentElements();
      this.scheduleAlignment();
    });
    this.alignmentMutationObserver.observe(root, { childList: true, subtree: true, characterData: true });
    this.observeAlignmentElements();
    window.addEventListener('resize', () => this.scheduleAlignment(), { signal: this.abort.signal });
    root.addEventListener('load', () => this.scheduleAlignment(), { capture: true, signal: this.abort.signal });
    document.fonts?.addEventListener('loadingdone', () => this.scheduleAlignment(), { signal: this.abort.signal });
    document.fonts?.ready.then(() => { if (!this.abort.signal.aborted) this.scheduleAlignment(); });
    this.scheduleAlignment();
  }

  destroy() {
    this.abort.abort();
    this.alignmentResizeObserver?.disconnect();
    this.alignmentMutationObserver.disconnect();
    cancelAnimationFrame(this.alignmentFrame);
    this.root.querySelectorAll('.bkw-bf-accessories').forEach(addons => addons.style.removeProperty('--bkw-addon-alignment'));
  }

  observeAlignmentElements() {
    const elements = new Set();
    this.root.querySelectorAll('[data-bkw-card]').forEach(card => {
      elements.add(card);
      const info = card.querySelector('.bkw-bf-product-info');
      if (info) Array.from(info.children).forEach(child => elements.add(child));
    });
    this.observedAlignmentElements.forEach(element => {
      if (!elements.has(element)) {
        this.alignmentResizeObserver?.unobserve(element);
        this.observedAlignmentElements.delete(element);
      }
    });
    elements.forEach(element => {
      if (!this.observedAlignmentElements.has(element)) {
        this.alignmentResizeObserver?.observe(element);
        this.observedAlignmentElements.add(element);
      }
    });
  }

  scheduleAlignment() {
    if (this.alignmentFrame) return;
    this.alignmentFrame = requestAnimationFrame(() => {
      this.alignmentFrame = 0;
      this.alignAccessories();
    });
  }

  alignAccessories() {
    const rows = [];
    this.root.querySelectorAll('[data-bkw-card]').forEach(card => {
      const addons = card.querySelector('.bkw-bf-accessories');
      if (!addons) return;
      if (!card.getClientRects().length || !addons.querySelector('[data-bkw-addon]') || !addons.getClientRects().length) {
        addons.style.removeProperty('--bkw-addon-alignment');
        return;
      }
      const top = card.getBoundingClientRect().top;
      let row = rows.find(item => Math.abs(item.top - top) < 1);
      if (!row) {
        row = { top, items: [] };
        rows.push(row);
      }
      const offset = parseFloat(addons.style.getPropertyValue('--bkw-addon-alignment')) || 0;
      row.items.push({ addons, naturalTop: addons.getBoundingClientRect().top - offset });
    });
    rows.forEach(row => {
      const maxTop = Math.max(...row.items.map(item => item.naturalTop));
      row.items.forEach(item => {
        const offset = Math.max(0, maxTop - item.naturalTop);
        const current = parseFloat(item.addons.style.getPropertyValue('--bkw-addon-alignment')) || 0;
        if (Math.abs(offset - current) > 0.5) item.addons.style.setProperty('--bkw-addon-alignment', `${offset}px`);
      });
    });
  }

  formatMoney(cents) {
    const [whole, fraction] = (Number(cents) / 100).toFixed(2).split('.');
    return ('€' + whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + fraction).replace(',00', '');
  }


  update(card) {
    let total = Number(card.dataset.unitPrice);
    let compareTotal = Math.max(total, Number(card.dataset.unitCompare) || total);
    card.querySelectorAll('[data-bkw-addon]').forEach(row => {
      const checkbox = row.querySelector('[data-addon-selected]');
      const selected = checkbox.checked && !checkbox.disabled;
      const quantity = row.querySelector('[data-addon-quantity]');
      const mobile = this.mobileQuery.matches;
      quantity.min = mobile ? '0' : '1';
      quantity.value = String(mobile && !selected ? 0 : Math.max(1, Math.min(99, Math.trunc(Number(quantity.value) || 1))));
      quantity.disabled = mobile ? checkbox.disabled : !selected;
      row.querySelectorAll('[data-addon-step]').forEach(button => {
        button.disabled = (mobile ? checkbox.disabled : !selected) || (Number(button.dataset.addonStep) < 0 && Number(quantity.value) <= (mobile ? 0 : 1)) || (Number(button.dataset.addonStep) > 0 && Number(quantity.value) >= 99);
      });
      row.classList.toggle('is-selected', selected);
      if (selected) {
        total += Number(row.dataset.unitPrice) * Number(quantity.value);
        compareTotal += Math.max(Number(row.dataset.unitPrice), Number(row.dataset.unitCompare) || 0) * Number(quantity.value);
      }
    });
    const compare = card.querySelector('[data-bkw-compare]');
    if (compare && !compare.hasAttribute('data-price-override')) {
      compare.hidden = compareTotal <= total;
      compare.textContent = this.formatMoney(compareTotal);
    }
    const price = card.querySelector('[data-bkw-total]');
    if (price && !price.hasAttribute('data-price-override')) price.textContent = this.formatMoney(total);
    const discount = card.querySelector('[data-bkw-discount]');
    if (discount) {
      const percent = compareTotal > total && compareTotal > 0 ? Math.round((compareTotal - total) * 100 / compareTotal) : 0;
      discount.hidden = percent <= 0;
      discount.querySelector('[data-bkw-discount-percent]').textContent = `${percent}%`;
    }
  }

  onChange(event) {
    if (event.target.matches('[data-addon-selected], [data-addon-quantity]')) {
      if (this.mobileQuery.matches && event.target.matches('[data-addon-quantity]')) {
        const checkbox = event.target.closest('[data-bkw-addon]').querySelector('[data-addon-selected]');
        if (!checkbox.disabled) checkbox.checked = Number(event.target.value) > 0;
      }
      this.update(event.target.closest('[data-bkw-card]'));
    }
  }

  onClick(event) {
    const step = event.target.closest('[data-addon-step]');
    if (step && !step.disabled) {
      const input = step.closest('[data-bkw-addon]').querySelector('[data-addon-quantity]');
      input.value = String(Number(input.value) + Number(step.dataset.addonStep));
      if (this.mobileQuery.matches) {
        step.closest('[data-bkw-addon]').querySelector('[data-addon-selected]').checked = Number(input.value) > 0;
      }
      this.update(step.closest('[data-bkw-card]'));
    }
    const button = event.target.closest('[data-bkw-add]');
    if (button && !button.disabled) this.add(button);
  }

  async add(button) {
    const card = button.closest('[data-bkw-card]');
    const variant = Number(card.dataset.variantId);
    if (!Number.isSafeInteger(variant) || variant <= 0 || card.dataset.available !== 'true') return;
    this.update(card);
    const quantities = new Map([[variant, 1]]);
    card.querySelectorAll('[data-bkw-addon]').forEach(row => {
      const input = row.querySelector('[data-addon-selected]');
      if (!input.checked || input.disabled) return;
      const id = Number(row.dataset.variantId);
      if (Number.isSafeInteger(id) && id > 0) quantities.set(id, (quantities.get(id) || 0) + Number(row.querySelector('[data-addon-quantity]').value));
    });
    const items = Array.from(quantities, ([id, quantity]) => ({ id, quantity }));
    const status = card.querySelector('.bkw-bf-cart-status');
    const original = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = this.messages.adding;
    status.hidden = true;
    try {
      const route = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${route}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }), signal: this.abort.signal });
      const data = await response.json();
      if (!response.ok || data.status >= 400) throw new Error(data.description || this.messages.error);
      status.textContent = this.messages.added;
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { items: data.items } }));
      if (window.theme?.Cart?.prototype?._onProductAdded) {
        try { window.theme.Cart.prototype._onProductAdded(); } catch {   }
      }
    } catch (error) {
      if (error.name === 'AbortError') return;
      status.textContent = error.message || this.messages.error;
    } finally {
      if (this.root.isConnected) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = original;
        status.hidden = false;
      }
    }
  }
}
if (!customElements.get('cust-bkw-bf-multiple-product')) {
  customElements.define('cust-bkw-bf-multiple-product', class extends HTMLElement {
    connectedCallback() { if (!this.controller) this.controller = new BkwProductController(this); }
    disconnectedCallback() { this.controller?.destroy(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust-bkw-bf-single-product"] && !Shopify.designMode) return;
  try {
    
class BkwProductController {
  constructor(root) {
    this.root = root;
    this.abort = new AbortController();
    this.mobileQuery = matchMedia('(max-width: 749px)');
    this.mobileQuery.addEventListener('change', () => {
      this.root.querySelectorAll('[data-bkw-card]').forEach(card => this.update(card));
    }, { signal: this.abort.signal });
    this.messages = JSON.parse(root.querySelector('[data-bkw-messages]').textContent);
    root.addEventListener('click', event => this.onClick(event), { signal: this.abort.signal });
    root.addEventListener('change', event => this.onChange(event), { signal: this.abort.signal });
    root.addEventListener('focusout', event => { if (event.target.matches('[data-addon-quantity]')) this.onChange(event); }, { signal: this.abort.signal });
    root.querySelectorAll('[data-bkw-card]').forEach(card => this.update(card));
  }

  destroy() { this.abort.abort(); }

  formatMoney(cents) {
    const [whole, fraction] = (Number(cents) / 100).toFixed(2).split('.');
    return ('€' + whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + fraction).replace(',00', '');
  }


  update(card) {
    let total = Number(card.dataset.unitPrice);
    let compareTotal = Math.max(total, Number(card.dataset.unitCompare) || total);
    card.querySelectorAll('[data-bkw-addon]').forEach(row => {
      const checkbox = row.querySelector('[data-addon-selected]');
      const selected = checkbox.checked && !checkbox.disabled;
      const quantity = row.querySelector('[data-addon-quantity]');
      const mobile = this.mobileQuery.matches;
      quantity.min = mobile ? '0' : '1';
      quantity.value = String(mobile && !selected ? 0 : Math.max(1, Math.min(99, Math.trunc(Number(quantity.value) || 1))));
      quantity.disabled = mobile ? checkbox.disabled : !selected;
      row.querySelectorAll('[data-addon-step]').forEach(button => {
        button.disabled = (mobile ? checkbox.disabled : !selected) || (Number(button.dataset.addonStep) < 0 && Number(quantity.value) <= (mobile ? 0 : 1)) || (Number(button.dataset.addonStep) > 0 && Number(quantity.value) >= 99);
      });
      row.classList.toggle('is-selected', selected);
      if (selected) {
        total += Number(row.dataset.unitPrice) * Number(quantity.value);
        compareTotal += Math.max(Number(row.dataset.unitPrice), Number(row.dataset.unitCompare) || 0) * Number(quantity.value);
      }
    });
    const compare = card.querySelector('[data-bkw-compare]');
    if (compare && !compare.hasAttribute('data-price-override')) {
      compare.hidden = compareTotal <= total;
      compare.textContent = this.formatMoney(compareTotal);
    }
    const price = card.querySelector('[data-bkw-total]');
    if (price && !price.hasAttribute('data-price-override')) price.textContent = this.formatMoney(total);
    const discount = card.querySelector('[data-bkw-discount]');
    if (discount) {
      const percent = compareTotal > total && compareTotal > 0 ? Math.round((compareTotal - total) * 100 / compareTotal) : 0;
      discount.hidden = percent <= 0;
      discount.querySelector('[data-bkw-discount-percent]').textContent = `${percent}%`;
    }
  }

  onChange(event) {
    if (event.target.matches('[data-addon-selected], [data-addon-quantity]')) {
      if (this.mobileQuery.matches && event.target.matches('[data-addon-quantity]')) {
        const checkbox = event.target.closest('[data-bkw-addon]').querySelector('[data-addon-selected]');
        if (!checkbox.disabled) checkbox.checked = Number(event.target.value) > 0;
      }
      this.update(event.target.closest('[data-bkw-card]'));
    }
  }

  onClick(event) {
    const step = event.target.closest('[data-addon-step]');
    if (step && !step.disabled) {
      const input = step.closest('[data-bkw-addon]').querySelector('[data-addon-quantity]');
      input.value = String(Number(input.value) + Number(step.dataset.addonStep));
      if (this.mobileQuery.matches) {
        step.closest('[data-bkw-addon]').querySelector('[data-addon-selected]').checked = Number(input.value) > 0;
      }
      this.update(step.closest('[data-bkw-card]'));
    }
    const button = event.target.closest('[data-bkw-add]');
    if (button && !button.disabled) this.add(button);
  }

  async add(button) {
    const card = button.closest('[data-bkw-card]');
    const variant = Number(card.dataset.variantId);
    if (!Number.isSafeInteger(variant) || variant <= 0 || card.dataset.available !== 'true') return;
    this.update(card);
    const quantities = new Map([[variant, 1]]);
    card.querySelectorAll('[data-bkw-addon]').forEach(row => {
      const input = row.querySelector('[data-addon-selected]');
      if (!input.checked || input.disabled) return;
      const id = Number(row.dataset.variantId);
      if (Number.isSafeInteger(id) && id > 0) quantities.set(id, (quantities.get(id) || 0) + Number(row.querySelector('[data-addon-quantity]').value));
    });
    const items = Array.from(quantities, ([id, quantity]) => ({ id, quantity }));
    const status = card.querySelector('.bkw-bf-cart-status');
    const original = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = this.messages.adding;
    status.hidden = true;
    try {
      const route = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${route}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }), signal: this.abort.signal });
      const data = await response.json();
      if (!response.ok || data.status >= 400) throw new Error(data.description || this.messages.error);
      status.textContent = this.messages.added;
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { items: data.items } }));
      if (window.theme?.Cart?.prototype?._onProductAdded) {
        try { window.theme.Cart.prototype._onProductAdded(); } catch {   }
      }
    } catch (error) {
      if (error.name === 'AbortError') return;
      status.textContent = error.message || this.messages.error;
    } finally {
      if (this.root.isConnected) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = original;
        status.hidden = false;
      }
    }
  }
}
if (!customElements.get('cust-bkw-bf-single-product')) {
  customElements.define('cust-bkw-bf-single-product', class extends HTMLElement {
    connectedCallback() { if (!this.controller) this.controller = new BkwProductController(this); }
    disconnectedCallback() { this.controller?.destroy(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust-bkw-bf-story-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var ROOT_SELECTOR = '.bkw26-sc';

  function initSection(root) {
    if (!root || root.dataset.bkw26Ready === 'true') return;
    root.dataset.bkw26Ready = 'true';
    var abort = new AbortController();
    function listen(target, type, handler, options) {
      target.addEventListener(type, handler, Object.assign({}, options, { signal: abort.signal }));
    }
    var lastFocus = null;
    root.querySelectorAll('a[href=""]').forEach(function (link) {
      link.setAttribute('aria-disabled', 'true');
      listen(link, 'click', function (event) { event.preventDefault(); });
    });


    var slides = Array.prototype.slice.call(root.querySelectorAll('.bkw26-sc__slide'));
    var sliderEl = root.querySelector('[data-bkw26-slider]');
    var prevBtn = root.querySelector('[data-bkw26-prev]');
    var nextBtn = root.querySelector('[data-bkw26-next]');
    var modals = Array.prototype.slice.call(root.querySelectorAll('[data-bkw26-modal]'));
    var count = slides.length;
    var activeIndex = 0;
    var swiper = null;
    var mobileCopies = [];

    if (!count) return;

    var track = root.querySelector('.bkw26-sc__track');
    var desktopAnimations = [];
    var exitSlides = [];

    function clearDesktopMotion() {
      desktopAnimations.forEach(function (animation) { animation.cancel(); });
      desktopAnimations = [];
      exitSlides.forEach(function (slide) { slide.remove(); });
      exitSlides = [];
      track.classList.remove('is-shifting');
    }

    function moveDesktop(direction) {
      if (desktopAnimations.length || count < 2) return;
      if (!slides[0].animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        setActiveSlide(activeIndex + direction);
        return;
      }

      var trackRect = track.getBoundingClientRect();
      if (!trackRect.width) {
        setActiveSlide(activeIndex + direction);
        return;
      }
      var before = slides.map(function (slide) {
        return {
          state: slide.dataset.bkw26State,
          rect: slide.getBoundingClientRect()
        };
      });
      var edge = direction > 0 ? 'prev' : 'next';
      before.forEach(function (item, i) {
        if (item.state !== edge || i === (activeIndex + direction + count) % count) return;
        var copy = slides[i].cloneNode(true);
        copy.classList.add('bkw26-sc__slide--exit');
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('inert', '');
        copy.removeAttribute('id');
        copy.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
        copy.querySelectorAll('button, a, [tabindex]').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
        copy.style.setProperty('--bkw26-exit-x', (item.rect.left - trackRect.left) + 'px');
        copy.style.setProperty('--bkw26-exit-y', (item.rect.top - trackRect.top) + 'px');
        copy.style.setProperty('--bkw26-exit-width', item.rect.width + 'px');
        exitSlides.push(copy);
      });

      setActiveSlide(activeIndex + direction);
      track.classList.add('is-shifting');
      var timing = { duration: 700, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' };
      slides.forEach(function (slide, i) {
        if (slide.dataset.bkw26State === 'hidden') return;
        var old = before[i];
        var rect = slide.getBoundingClientRect();
        var entering = old.state === 'hidden' ||
          (old.state === edge && slide.dataset.bkw26State !== 'active');
        var dx = entering ? direction * (rect.width + 16) : old.rect.left - rect.left;
        var dy = entering ? 0 : old.rect.top - rect.top;
        var sx = entering ? 1 : old.rect.width / rect.width;
        var sy = entering ? 1 : old.rect.height / rect.height;
        desktopAnimations.push(slide.animate([
          { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(' + sx + ', ' + sy + ')', opacity: entering ? 0 : 1 },
          { transform: 'translate(0, 0) scale(1, 1)', opacity: 1 }
        ], timing));
      });
      exitSlides.forEach(function (copy) {
        track.appendChild(copy);
        desktopAnimations.push(copy.animate([
          { transform: 'translateX(0)', opacity: 1 },
          { transform: 'translateX(' + (-direction * (copy.getBoundingClientRect().width + 16)) + 'px)', opacity: 0 }
        ], timing));
      });
      Promise.all(desktopAnimations.map(function (animation) { return animation.finished; }))
        .then(clearDesktopMotion, function () {});
    }

    function setActiveSlide(index) {
      activeIndex = ((index % count) + count) % count;
      slides.forEach(function (slide, i) {
        var state = 'hidden';
        if (i === activeIndex) {
          state = 'active';
        } else if (count > 1 && i === ((activeIndex - 1 + count) % count)) {
          state = 'prev';
        } else if (count > 1 && i === ((activeIndex + 1) % count)) {
          state = 'next';
        }
        slide.dataset.bkw26State = state;
        slide.style.order = state === 'prev' ? '0' : state === 'active' ? '1' : state === 'next' ? '2' : '3';
      });
    }

    function destroySwiper() {

      if (swiper) {
        activeIndex = swiper.realIndex % count;
        swiper.destroy(true, true);
        swiper = null;
      }
      mobileCopies.forEach(function (slide) { slide.remove(); });
      mobileCopies = [];
      slides.forEach(function (slide) { track.appendChild(slide); });
    }

    function initSwiper() {
      if (swiper || !window.Swiper) return;
      slides.forEach(function (slide) { slide.style.removeProperty('order'); });
      if (count > 1 && count < 6) {
        for (var i = count; i < 6; i++) {
          var copy = slides[i % count].cloneNode(true);
          copy.style.removeProperty('order');
          copy.removeAttribute('data-bkw26-state');
          copy.querySelectorAll('[id]').forEach(function (node) { node.removeAttribute('id'); });
          track.appendChild(copy);
          mobileCopies.push(copy);
        }
      }
      swiper = new window.Swiper(sliderEl, {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 8,
        loop: count > 1,
        initialSlide: activeIndex
      });
      swiper.slideToLoop(activeIndex, 0, false);

    }

    function applyMode() {
      clearDesktopMotion();
      if (window.matchMedia('(min-width: 990px)').matches) {
        destroySwiper();
        setActiveSlide(activeIndex);
      } else {
        initSwiper();
      }
    }

    if (prevBtn) {
      listen(prevBtn, 'click', function () {
        if (swiper) swiper.slidePrev();
        else moveDesktop(-1);
      });
    }
    if (nextBtn) {
      listen(nextBtn, 'click', function () {
        if (swiper) swiper.slideNext();
        else moveDesktop(1);
      });
    }

    var DRAG_DISTANCE = 40;
    var dragStartX = 0;
    var dragStartY = 0;
    var dragActive = false;
    var dragTriggered = false;

    if (sliderEl) {
      listen(sliderEl, 'mousedown', function (e) {
        if (swiper || e.button !== 0) return;
        if (e.target.closest('[data-bkw26-prev], [data-bkw26-next]')) return;
        dragStartX = e.clientX;
        dragStartY = e.clientY;
        dragActive = true;
        dragTriggered = false;
        sliderEl.classList.add('is-dragging');
      });

      listen(window, 'mousemove', function (e) {
        if (!dragActive) return;
        var dx = e.clientX - dragStartX;
        var dy = e.clientY - dragStartY;
        if (Math.abs(dx) >= DRAG_DISTANCE && Math.abs(dx) > Math.abs(dy)) {
          dragTriggered = true;
          dragActive = false;
          sliderEl.classList.remove('is-dragging');
          moveDesktop(dx < 0 ? 1 : -1);
        }
      });

      listen(window, 'mouseup', function () {
        dragActive = false;
        sliderEl.classList.remove('is-dragging');
      });

      listen(sliderEl, 'click', function (e) {
        if (!dragTriggered) return;
        dragTriggered = false;
        e.preventDefault();
        e.stopPropagation();
      }, true);
    }

    listen(window, 'resize', applyMode);
    listen(document, 'shopify:section:unload', function (event) {
      if (!event.target.contains(root)) return;
      clearDesktopMotion();
      destroySwiper();
      abort.abort();
      delete root.dataset.bkw26Ready;
      root.querySelectorAll('[data-bkw26-modal].is-open').forEach(closeModal);
    });

    function openModal(modal) {
      if (!modal) return;
      lastFocus = document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
      modal.querySelector('[data-bkw26-modal-close].bkw26-sc__modal-close')?.focus();
    }

    function closeModal(modal) {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
      lastFocus?.focus();
    }

    listen(root, 'click', function (event) {
      var button = event.target.closest('[data-bkw26-open-modal]');
      if (!button || !root.contains(button)) return;
      var index = Number(button.dataset.bkw26OpenModal);
      if (modals[index]) openModal(modals[index]);
    });

    modals.forEach(function (modal) {
      modal.querySelectorAll('[data-bkw26-modal-close]').forEach(function (btn) {
        listen(btn, 'click', function () {
          closeModal(modal);
        });
      });
    });

    modals.forEach(function (modal) {
      var mediaImgs = Array.prototype.slice.call(modal.querySelectorAll('[data-bkw26-media-img]'));
      var thumbs = Array.prototype.slice.call(modal.querySelectorAll('[data-bkw26-thumb]'));
      var mediaPrev = modal.querySelector('[data-bkw26-media-prev]');
      var mediaNext = modal.querySelector('[data-bkw26-media-next]');
      var mediaIndex = 0;

      function setMedia(index) {
        var n = mediaImgs.length;
        if (!n) return;
        mediaIndex = ((index % n) + n) % n;
        mediaImgs.forEach(function (img, i) {
          img.classList.toggle('is-active', i === mediaIndex);
        });
        thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle('is-active', i === mediaIndex);
        });
      }

      if (mediaPrev) {
        listen(mediaPrev, 'click', function () {
          setMedia(mediaIndex - 1);
        });
      }
      if (mediaNext) {
        listen(mediaNext, 'click', function () {
          setMedia(mediaIndex + 1);
        });
      }
      thumbs.forEach(function (thumb) {
        listen(thumb, 'click', function () {
          setMedia(Number(thumb.dataset.bkw26Thumb));
        });
      });

      var mediaEl = modal.querySelector('[data-bkw26-media]');
      if (mediaEl) {
        var swipeX = 0;
        var swipeY = 0;

        listen(mediaEl, 'touchstart', function (e) {
          swipeX = e.touches[0].clientX;
          swipeY = e.touches[0].clientY;
        }, { passive: true });

        listen(mediaEl, 'touchend', function (e) {
          var dx = e.changedTouches[0].clientX - swipeX;
          var dy = e.changedTouches[0].clientY - swipeY;
          if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
          setMedia(mediaIndex + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }
    });

    modals.forEach(function (modal) {
      var panel = modal.querySelector('.bkw26-sc__modal-panel');
      var toggle = modal.querySelector('[data-bkw26-toggle]');
      var desc = modal.querySelector('[data-bkw26-desc]');
      if (!panel || !toggle || !desc) return;

      panel.classList.add('is-collapsible');

      var more = modal.querySelector('[data-bkw26-toggle-more]');
      var less = modal.querySelector('[data-bkw26-toggle-less]');

      listen(toggle, 'click', function () {
        var expanded = !panel.classList.contains('is-expanded');
        panel.classList.toggle('is-expanded', expanded);
        if (more) more.hidden = expanded;
        if (less) less.hidden = !expanded;
      });
    });

    function addToCart(button) {
      var raw = button.dataset.variantIds;
      if (!raw || button.classList.contains('is-loading')) return;

      var ids = raw.split(',').map(function (s) { return Number(s); }).filter(function (n) { return n > 0; });
      if (!ids.length) return;

      button.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: ids.map(function (id) {
            return { id: id, quantity: 1 };
          })
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to add product to cart');
          return response.json();
        })
        .then(function () {
          if (typeof theme !== 'undefined' && theme.Cart && theme.Cart.prototype && typeof theme.Cart.prototype._onProductAdded === 'function') {
            theme.Cart.prototype._onProductAdded();
          }
        })
        .catch(function (error) {
          console.error('[bkw26-sc] add to cart failed', error);
        })
        .finally(function () {
          button.classList.remove('is-loading');
        });
    }

    modals.forEach(function (modal) {
      var atcBtn = modal.querySelector('[data-bkw26-atc]');
      if (atcBtn) {
        listen(atcBtn, 'click', function () {
          addToCart(atcBtn);
        });
      }
    });

    listen(document, 'keydown', function (event) {
      var modal = root.querySelector('[data-bkw26-modal].is-open');
      if (!modal) return;
      if (event.key === 'Escape') { closeModal(modal); return; }
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(modal.querySelectorAll('button:not([disabled]),a[href],[tabindex="0"]')).filter(function(n){return n.getClientRects().length;});
      if (!focusable.length) return;
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    applyMode();
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target || !target.querySelector) return;

    var root = target.classList && target.classList.contains('bkw26-sc')
      ? target
      : target.querySelector(ROOT_SELECTOR);

    if (root) initSection(root);
    else initAll();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust-bkw-bf-subscribe"] && !Shopify.designMode) return;
  try {
    
class BkwSubscriptionController {
  constructor(root) {
    this.id = root.id || root.closest('[id]')?.id || 'bkw-subscription';
    this.abort = new AbortController();
    this.boundForms = new Set();
    this.settings = JSON.parse(root.querySelector('[data-bkw-subscription-settings]').textContent);
    this.releaseRulesPopup = () => {};
    this.bindRulesPopup(root);
    root.querySelectorAll('[data-bkw-subscription-form]').forEach(form => this.bindForm(form));
  }
  destroy() {
    if (this.rulesDialog?.open) this.rulesDialog.close();
    this.releaseRulesPopup();
    this.abort.abort();
    this.boundForms.forEach(form => { delete form.dataset.bkwBound; });
    this.boundForms.clear();
  }
  bindRulesPopup(root) {
    const dialog = root.querySelector('.bkw-bf-subscribe-popup');
    const trigger = root.querySelector('[data-bkw-subscribe-popup-open]');
    if (!dialog || !trigger || typeof dialog.showModal !== 'function') return;
    this.rulesDialog = dialog;
    const options = { signal: this.abort.signal };
    let previousOverflow;
    let previousFocus;
    let scrollLocked = false;
    this.releaseRulesPopup = () => {
      if (!scrollLocked) return;
      document.documentElement.style.overflow = previousOverflow;
      scrollLocked = false;
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    };
    trigger.addEventListener('click', () => {
      if (dialog.open) return;
      previousFocus = document.activeElement;
      dialog.showModal();
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      scrollLocked = true;
    }, options);
    root.querySelector('[data-bkw-subscribe-popup-close]').addEventListener('click', () => dialog.close(), options);
    dialog.addEventListener('close', this.releaseRulesPopup, options);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    }, options);
  }
    bindForm(form) {
      if (this.boundForms.has(form)) return;
      this.boundForms.add(form);
      form.dataset.bkwBound = this.id;
      form.addEventListener('submit', event => { event.preventDefault(); this.submit(form); }, { signal: this.abort.signal });
    }
    async submit(form) {
      const settings = this.settings;
      const email = form.elements.email;
      const consent = form.elements.consent;
      const status = form.querySelector('[role="status"]');
      const button = form.querySelector('[type="submit"]');
      const show = message => { status.textContent = message; status.hidden = false; };
      email.removeAttribute('aria-invalid'); consent.removeAttribute('aria-invalid');
      if (!email.value.trim() || !email.validity.valid) { show(settings.email_error_text); email.setAttribute('aria-invalid', 'true'); email.focus(); return; }
      if (!consent.checked) { show(settings.disclaimer_error_text); consent.setAttribute('aria-invalid', 'true'); consent.focus(); return; }
      if (!settings.campaign_enabled || !settings.contact_list_id) { show(settings.not_open_text); return; }
      const integration = window.theme?.emailSubscription;
      if (!integration?.apiUrl) { show(settings.general_error_text); return; }
      const fields = [];
      for (const type of ['single', 'subscription_text', 'multiple']) {
        for (let i = 1; i <= 5; i += 1) {
          const prefix = `${type}_${i}_`;
          if (!settings[`${prefix}id`]) continue;
          let value = settings[`${prefix}value`];
          if (type === 'single') value = Number(value);
          if (type === 'multiple') value = String(value || '').split(',').filter(x => x.trim()).map(Number);
          if ((type === 'single' && !Number.isFinite(value)) || (Array.isArray(value) && value.some(x => !Number.isFinite(x)))) { show(settings.general_error_text); return; }
          fields.push({ id: String(settings[`${prefix}id`]), type: type === 'subscription_text' ? 'text' : type, value, overwrite: String(settings[`${prefix}overwrite`]) === 'true' });
        }
      }
      const original = button.textContent;
      button.disabled = true; button.setAttribute('aria-busy', 'true'); button.textContent = settings.loading_text;
      try {
        const response = await fetch(integration.apiUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', apiKey: integration.apiKey, traceId: crypto.randomUUID(), 'X-appid': integration.xAppid, 'Accepted-Language': integration.acceptedLanguage }, body: JSON.stringify({ email: email.value.trim(), contactListId: settings.contact_list_id, fields }), signal: this.abort.signal });
        const data = await response.json();
        if (!response.ok || data.message !== 'Success') throw new Error('Subscription failed');
        show(settings.success_message); form.reset();
      } catch (error) { if (error.name !== 'AbortError') show(settings.general_error_text); }
      finally { if (form.isConnected) { button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = original; } }
    }
}

if (!customElements.get('cust-bkw-bf-subscribe')) {
  customElements.define('cust-bkw-bf-subscribe', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new BkwSubscriptionController(this);
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { this.controller?.destroy(); this.controller = null; clearInterval(this.timer); }
    tick() {
      this.querySelectorAll('[data-bkw-countdown]').forEach(timer => {
        const end = Date.parse(timer.dataset.bkwCountdown);
        const remaining = Number.isFinite(end) ? Math.max(0, Math.floor((end - Date.now()) / 1000)) : 0;
        const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
        timer.querySelectorAll('[data-unit]').forEach(unit => { unit.textContent = String(values[unit.dataset.unit]).padStart(2, '0'); });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_box-content"] && !Shopify.designMode) return;
  try {
    
  let swiperInstances = []; // Array to hold swiper instances

  function initCustSliderImageContent() {
    // Check if the window width is less than or equal to 749px (mobile)
    if (window.innerWidth <= 749) {
      var sliders = document.querySelectorAll('[data-js-cust-box-content-slider]');
      if (!sliders.length) return; // Exit if no sliders are found

      sliders.forEach(function (slider, index) {
        if (!swiperInstances[index]) { // Check if swiper instance already exists
          swiperInstances[index] = new Swiper(slider, {
            spaceBetween: 0,
            slidesPerView: 'auto',
            loop: false,
          });
        }
      });
    } else {
      // Destroy swiper instances on desktop
      swiperInstances.forEach(function (swiper) {
        if (swiper) {
          swiper.destroy(true, true); // Destroy the swiper instance
        }
      });
      swiperInstances = []; // Clear the array
    }
  }

  function initScrollToSection() {
    var scrollPosEnd = 0;
    document.querySelectorAll('.cust-box-content__button').forEach(function(element){
      var section_id = element.getAttribute('href');

      // Only add click event if href starts with "#"
      if (section_id.startsWith("#")) {
        element.onclick = function(e){
          e.preventDefault();
          var sectionElem = document.querySelector(section_id);
          if(sectionElem) {
            var scrollDiv;
            scrollDiv = sectionElem.offsetTop;

            scrollPosEnd = scrollDiv - 100;
            window.scrollTo({ top: scrollDiv, behavior: 'smooth' });
          }
        };
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function() {
    initCustSliderImageContent();
    initScrollToSection();

    // Add event listener for window resize
    window.addEventListener("resize", function() {
      // Re-initialize the slider on resize
      initCustSliderImageContent();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_faq-with-image"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const items = document.querySelectorAll('[data-item]');
    items.forEach(item => {
      item.addEventListener('click', function() {
        this.classList.toggle('active');
        items.forEach(otherItem => {
          if (otherItem !== this) {
            otherItem.classList.remove('active');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ef-section-button-tabs"] && !Shopify.designMode) return;
  try {
    
  if (document.querySelectorAll('.ef-button-tabs--row').length > 0) {
    document.querySelectorAll('.ef-button-tabs--row').forEach(function(elem) {
      elem.querySelectorAll('.ef-section-button-tabs__tab-btn').forEach(function(tab) {

        if (tab.classList.contains('active') == false) {
          var linked_to = tab.getAttribute('data-linked-to');
          if (linked_to == 'section') {
            var target_1 = tab.getAttribute('data-first-section');
            var target_2 = tab.getAttribute('data-second-section');
            var target_3 = tab.getAttribute('data-third-section');
            if (target_1 != '' && document.querySelector(target_1)) document.querySelector(target_1).style.display = 'none';
            if (target_2 != '' && document.querySelector(target_2)) document.querySelector(target_2).style.display = 'none';
            if (target_3 != '' && document.querySelector(target_3)) document.querySelector(target_3).style.display = 'none';
          } else if (linked_to == 'blocks') {
            var block_id = tab.getAttribute('data-block-id');
            if (block_id != '' && document.querySelectorAll('.star_product_block[data-block-id="' + block_id + '"]').length > 0) {
              document.querySelectorAll('.star_product_block[data-block-id="' + block_id + '"]').forEach(function(elem) { elem.style.display = 'none'; });
              if (document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]')) {
                document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]').style.display = 'none';
              }
            }
          }
        }

        tab.addEventListener('click', function(e) {
          var parentElem = this.closest('.ef-button-tabs--row');
          var current_target_1 = parentElem.querySelector('.ef-section-button-tabs__tab-btn.active').getAttribute('data-first-section');
          var current_target_2 = parentElem.querySelector('.ef-section-button-tabs__tab-btn.active').getAttribute('data-second-section');
          var current_target_3 = parentElem.querySelector('.ef-section-button-tabs__tab-btn.active').getAttribute('data-third-section');
          if (current_target_1 != '' && document.querySelector(current_target_1)) document.querySelector(current_target_1).style.display = 'none';
          if (current_target_2 != '' && document.querySelector(current_target_2)) document.querySelector(current_target_2).style.display = 'none';
          if (current_target_3 != '' && document.querySelector(current_target_3)) document.querySelector(current_target_3).style.display = 'none';
          parentElem.querySelector('.ef-section-button-tabs__tab-btn.active').classList.remove('active');
          this.classList.add('active');
          var linked_to = this.getAttribute('data-linked-to');
          if (linked_to == 'section') {
            var target_1 = this.getAttribute('data-first-section');
            var target_2 = this.getAttribute('data-second-section');
            var target_3 = this.getAttribute('data-third-section');
            if (target_1 != '' && document.querySelector(target_1)) document.querySelector(target_1).style.display = 'block';
            if (target_2 != '' && document.querySelector(target_2)) document.querySelector(target_2).style.display = 'block';
            if (target_3 != '' && document.querySelector(target_3)) document.querySelector(target_3).style.display = 'block';
          } else if (linked_to == 'blocks') {
            document.querySelectorAll('.star-page-product-multiple-tab-section .star_product_block').forEach(function(elem) {
              elem.style.display = 'none';
            });
            if (document.querySelectorAll('.star-page-product-multiple-tab-section .view_more_wrapper').length > 0) {
              document.querySelectorAll('.star-page-product-multiple-tab-section .view_more_wrapper').forEach(function(elem) {
                elem.style.display = 'none';
              });
            }
            var block_id = this.getAttribute('data-block-id');
            if (block_id != '' && document.querySelectorAll('.star_product_block[data-block-id="' + block_id + '"]').length > 0) {
              document.querySelectorAll('.star_product_block[data-block-id="' + block_id + '"]').forEach(function(elem, index) {
                var products_count = elem.closest('.star-page-product-multiple-tab-section').getAttribute('data-products-count');
                var products_count_m = elem.closest('.star-page-product-multiple-tab-section').getAttribute('data-products-count-m');
                if (window.innerWidth < 750) {
                  if (index < products_count_m) elem.style.display = 'flex';
                } else {
                  if (index < products_count) elem.style.display = 'flex';
                }
              });
              if (document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]')) {
                if (window.innerWidth < 750) {
                  if (!document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]').classList.contains('hideMobile'))
                    document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]').style.display = 'flex';
                } else {
                  if (!document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]').classList.contains('hideDesktop'))
                    document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]').style.display = 'flex';
                }
              }
            }
          }
          if (typeof alignProductTitleRow === 'function') alignProductTitleRow();
        });
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m11-bf-grid-section"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function(){
        const btn = document.querySelector('.m11-bf-grid__btn');
        const wrapper = document.querySelector('.m11-bf-grid__popup');
        const closeIcon = document.querySelector('.m11-bf-grid__popup .close-icon');
        btn.addEventListener('click', function(){
            wrapper.style.display = 'block';
        });
        closeIcon.addEventListener('click', function(){
            wrapper.style.display = 'none';
        });
        window.addEventListener('click', function(e){
            if(e.target === wrapper && e.target != document.querySelector('.m9-icon-with-popup-inner')){
                wrapper.style.display = 'none';
            }
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m11-star-title"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function(){
        if(document.querySelectorAll('.m11-star-title-link').length > 0){
            document.querySelectorAll('.m11-star-title-link').forEach(function(link){
              const popupId = link.getAttribute('data-popup-id');
              const wrapper = document.querySelector(`.${popupId}`);
              const closeIcon = document.querySelector(`.${popupId} .popup-close-button`);
              link.addEventListener('click', function(e){
                  e.preventDefault();
                  document.querySelector(`.${popupId}`).style.display = 'block';
              });
              closeIcon.addEventListener('click', function(){
                  wrapper.style.display = 'none';
              });
              window.addEventListener('click', function(e){
                  if(e.target === wrapper && e.target != document.querySelector('.m11-title-rules-popup .popup-content')){
                      wrapper.style.display = 'none';
                  }
              });
            });
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m8-timeline"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
      const popupButton = document.querySelector('.m8-timeline-section .bottom-line a');
      const popupButtonWrapper = document.querySelector('.popup-t-c-wrapper');
      const popupCloseButton = document.querySelector('.popup-close-button');

      popupButton.addEventListener('click', function() {
        popupButtonWrapper.style.display = 'block';
        document.body.classList.add('overflow-hidden');
      });

      popupCloseButton.addEventListener('click', function() {
        popupButtonWrapper.style.display = 'none';
        document.body.classList.remove('overflow-hidden');
      });

      popupButtonWrapper.addEventListener('click', function(e) {
        if(!e.target.classList.contains('popup-t-c-popup-content') && !e.target.closest('.popup-t-c-popup-content')){
          popupButtonWrapper.style.display = 'none';
          document.body.classList.remove('overflow-hidden');
        }
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m9-icon-with-popup"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function(){
        const icon = document.querySelector('.m9-icon-with-popup-icon');
        const wrapper = document.querySelector('.m9-icon-with-popup-wrapper');
        const closeIcon = document.querySelector('.m9-icon-with-popup-inner .close-icon');
        icon.addEventListener('click', function(){
            wrapper.style.display = 'block';
            icon.style.display = 'none';
        });
        closeIcon.addEventListener('click', function(){
            wrapper.style.display = 'none';
            icon.style.display = 'block';
        });
        window.addEventListener('click', function(e){
            if(e.target === wrapper && e.target != document.querySelector('.m9-icon-with-popup-inner')){
                wrapper.style.display = 'none';
                icon.style.display = 'block';
            }
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-page-product-slider-v1"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelectorAll('.star-products-container.swiper');
    section.forEach(section => {
        const swiper = new Swiper(section, {
            slidesPerView: section.getAttribute('data-per-row-m'),
            spaceBetween: 12,
            navigation: {
                nextEl: section.querySelector('.swiper-button-next'),
                prevEl: section.querySelector('.swiper-button-prev'),
            },
            scrollbar: {
                el: section.querySelector('.swiper-scrollbar'),
            },
            breakpoints: {
                749: {
                    slidesPerView: section.getAttribute('data-per-row'),
                    spaceBetween: 24,
                },
            },
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-page-product-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelectorAll('.star-products-container.swiper');
    section.forEach(section => {
        const swiper = new Swiper(section, {
            slidesPerView: section.getAttribute('data-per-row-m'),
            spaceBetween: 12,
            navigation: {
                nextEl: section.querySelector('.swiper-button-next'),
                prevEl: section.querySelector('.swiper-button-prev'),
            },
            scrollbar: {
                el: section.querySelector('.swiper-scrollbar'),
            },
            breakpoints: {
                749: {
                    slidesPerView: section.getAttribute('data-per-row'),
                    spaceBetween: 24,
                },
            },
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-product-multiple"] && !Shopify.designMode) return;
  try {
    
    function addProducts(elem, type) {
      document.querySelectorAll(elem).forEach(function (elem) {
        elem.onclick = function (e) {
          e.preventDefault();

          var buttonElement = this.querySelector('.btn-text');
          var loaderElement = this.querySelector('.loader');
          var quantity = this.getAttribute('data-quantity').split(',');

          buttonElement.style.display = 'none';
          loaderElement.classList.remove('hide');

          var json = [];
          var products = elem.getAttribute('data-variant-ids');
          if(products != ''){
            var products_arr = products.split(',');
            products_arr.forEach(function(item,index){
              if(item != '')
                json.push({ 'id': item, 'quantity': quantity[index] });
            });
          }

          var formData = JSON.stringify({'items': json});

          fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
            },
            body: formData,
          })
            .then(function (response) {
              return response.json();
            })
            .then(function (json) {
              theme.Cart.prototype._onProductAdded();
            })
            .finally(() => {
                buttonElement.style.display = 'block';
                loaderElement.classList.add('hide');
            });
        };
      });
    }

    if (document.querySelectorAll('.btn--atc').length > 0) {
      addProducts('.btn--atc', '');
    }

  } catch(e) { console.error(e); }
})();
})();
